import { render, staticRenderFns } from "./SpecialTierForm.vue?vue&type=template&id=dcf423be&scoped=true&"
import script from "./SpecialTierForm.vue?vue&type=script&lang=js&"
export * from "./SpecialTierForm.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTierForm.vue?vue&type=style&index=0&id=dcf423be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf423be",
  null
  
)

export default component.exports